import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bffb5f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-container" }
const _hoisted_2 = { class: "select-container__label" }
const _hoisted_3 = ["data-test", "disabled", "value"]
const _hoisted_4 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = {
  key: 0,
  class: "text-error-700 ml-1 text-sm"
}

import { Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NativeSelect',
  props: {
    modelValue: {},
    options: {},
    placeholder: {},
    hasError: { type: Boolean },
    disabled: { type: Boolean },
    errorLabel: {},
    labelText: {},
    validationField: {}
  },
  emits: ["update:modelValue", "validate"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.labelText), 1),
    _createElementVNode("select", {
      "data-test": `select-${_ctx.validationField}`,
      disabled: _ctx.disabled,
      value: _ctx.modelValue,
      class: _normalizeClass([
				'select-container__select',
				{ 'select-container__select--error': _ctx.hasError },
				{ 'text-gray-700': !_ctx.modelValue },
			]),
      onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('validate', _ctx.validationField))),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)))
    }, [
      _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.placeholder), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: `option-${option.value}-${index}`,
          value: option.value,
          disabled: option.disabled
        }, _toDisplayString(option.label), 9, _hoisted_5))
      }), 128))
    ], 42, _hoisted_3),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errorLabel), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})